




















































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { getScreenSizeVariant } from '@/vue-app/utils/screen';

@Component({ name: 'ContractSavingsCollectionReminder' })
export default class ContractSavingsCollectionReminder extends Vue {
  @Prop(Boolean)
  readonly isOpen!: boolean;

  i18n_namespace = 'components.contract-savings.ready';

  small_screen: null | boolean = null;

  nextStep() {
    this.$emit('nextStep');
  }

  mounted() {
    this.small_screen = getScreenSizeVariant() === 'small';
  }
}

